import React from 'react';
import styled from 'styled-components';
import { ROUTES } from '@constants/routes';
import { TransparentFlatButton } from '@ui/buttons';
import { SkeletonButton } from '@ui/buttons/SkeletonButton';
import { CloseButton } from '@ui/buttons/CloseButton';
import { Container } from '@ui';

const Wrapper = styled.div``;
const ActionsButtonWrapper = styled.div`
  button {
    padding: 6px 16px;
  }
`;
const MenuWrapper = styled.div`
  position: fixed;
  top: ${({ $top }) => $top}px;
  right: ${({ $right }) => $right}px;
  min-width: 260px;

  border: 1px solid ${({ theme }) => theme.themeColors.text};
  border-radius: 6px;
  background: ${({ theme }) => theme.themeColors.header};
  box-shadow: 0 0 1px 1px rgba(0, 0, 0, 0.05);
  padding: 0 16px;
  z-index: 10000;
`;
const CloseButtonWrapper = styled.div`
  position: absolute;
  top: 8px;
  right: 8px;
  cursor: pointer;

  svg {
    height: 12px;
    width: 12px;
  }

  g {
    fill: ${({ theme }) => theme.themeColors.text};
  }
`;

export const DocRowActionsMenu = ({ doc }) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const [coords, setCoords] = React.useState({ top: 0, right: 0 });
  const triggerRef = React.useRef(null);
  const menuRef = React.useRef(null);

  const isCsv = doc.doc_content_type === 'text/csv';

  const openMenu = () => {
    const rect = triggerRef.current.getBoundingClientRect();
    setCoords({ top: rect.bottom + 8, right: window.innerWidth - rect.right });
    setIsOpen(true);
  };

  const handleToggle = () => {
    if (isOpen) {
      setIsOpen(false);
    } else {
      openMenu();
    }
  };

  React.useEffect(() => {
    if (!isOpen) return undefined;
    const handleMouseDown = (event) => {
      const inTrigger = triggerRef.current && triggerRef.current.contains(event.target);
      const inMenu = menuRef.current && menuRef.current.contains(event.target);
      if (!inTrigger && !inMenu) {
        setIsOpen(false);
      }
    };
    const handleScroll = () => setIsOpen(false);
    document.addEventListener('mousedown', handleMouseDown);
    window.addEventListener('scroll', handleScroll, true);
    window.addEventListener('resize', handleScroll);
    return () => {
      document.removeEventListener('mousedown', handleMouseDown);
      window.removeEventListener('scroll', handleScroll, true);
      window.removeEventListener('resize', handleScroll);
    };
  }, [isOpen]);

  const handleQueryNowClick = () => {
    const url = `${ROUTES.docProcessingToDA}?fid=${doc.doc_id}`;
    window.open(url, '_blank');
    setIsOpen(false);
  };

  const handleUseInAgentClick = () => {
    const url = `${ROUTES.dataAnalystAgent}?csv-doc-id=${doc.doc_id}`;
    window.open(url, '_blank');
    setIsOpen(false);
  };

  return (
    <Wrapper>
      <ActionsButtonWrapper ref={triggerRef}>
        <SkeletonButton onClick={handleToggle}>Actions</SkeletonButton>
      </ActionsButtonWrapper>
      {isOpen ? (
        <MenuWrapper ref={menuRef} $top={coords.top} $right={coords.right}>
          <Container bottom={24}>
            <CloseButtonWrapper>
              <CloseButton onClick={() => setIsOpen(false)} />
            </CloseButtonWrapper>
            <Container top={36}></Container>
            <Container top={8}>
              <TransparentFlatButton fullWidth onClick={handleQueryNowClick}>
                Query Document Now
              </TransparentFlatButton>
            </Container>
            {isCsv ? (
              <Container top={8}>
                <TransparentFlatButton fullWidth onClick={handleUseInAgentClick}>
                  Use in Digital Analyst Agent
                </TransparentFlatButton>
              </Container>
            ) : null}
          </Container>
        </MenuWrapper>
      ) : null}
    </Wrapper>
  );
};
